import { useController } from '../../../contexts';
import { useValidateConditionalContent } from '../../useValidateConditionalContent';

export const useConditionalContentController = () => {
  const validate = useValidateConditionalContent();
  return useController({
    name: 'conditionalContent',
    rules: {
      validate,
    },
  });
};
